import { render, staticRenderFns } from "./legal.vue?vue&type=template&id=9b9d8970&scoped=true&"
import script from "./legal.vue?vue&type=script&lang=ts&"
export * from "./legal.vue?vue&type=script&lang=ts&"
import style0 from "./legal.vue?vue&type=style&index=0&id=9b9d8970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9d8970",
  null
  
)

export default component.exports